// @ts-nocheck
import { memo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import Button from 'js/components/Button'
import Modal from 'js/components/Modal/Modal'
import SkipNavigationLink from 'js/components/SkipNavigationLink'
import Text from 'js/components/Text/Text'
import TiptapView from 'js/components/Tiptap/TiptapView'
import Navigation from 'js/layout/Navigation/Navigation'
import PreHeader from 'js/layout/PreHeader/PreHeader'
import { START_OF_CONTENT_ELEMENT_ID } from 'js/lib/constants'

import styles from './Header.module.css'

const Header = memo(({ site, viewer }) => {
    const { t } = useTranslation()

    const [modalVisible, setModalVisible] = useState(true)
    const hideModal = () => setModalVisible(false)

    if (!site || !viewer) {
        return null
    }

    return (
        <header className={styles.wrapper}>
            <SkipNavigationLink contentId={START_OF_CONTENT_ELEMENT_ID} />

            {site.showPreheader && <PreHeader site={site} />}

            <Navigation site={site} viewer={viewer} />

            {viewer.isBanned && (
                <Modal
                    isVisible={modalVisible}
                    title={t('account.banned-title')}
                    size="small"
                >
                    {viewer.banReason && viewer.isAutoBan && (
                        <Text
                            size="small"
                            as="p"
                            style={{ marginBottom: '8px' }}
                        >
                            <Trans
                                i18nKey="account.banned-reason"
                                values={{ reason: viewer.banReason }}
                                components={{ strong: <strong /> }}
                            />
                        </Text>
                    )}

                    {site.blockedUserIntroMessage ? (
                        <TiptapView content={site.blockedUserIntroMessage} />
                    ) : (
                        <Text size="small" as="p">
                            <Trans i18nKey="account.banned-description">
                                Contact the site administrator or go to
                                <a href="https://account.pleio.nl/profile/">
                                    {{ url: 'account.pleio.nl' }}
                                </a>
                                and log in with a different account.
                            </Trans>
                        </Text>
                    )}

                    <Button
                        size="normal"
                        variant="primary"
                        style={{ margin: '24px auto 0' }}
                        onClick={hideModal}
                    >
                        {t('action.ok')}
                    </Button>
                </Modal>
            )}
        </header>
    )
})

Header.displayName = 'Header'

export default Header
